import { Spin } from 'antd';
import React, { lazy, Suspense }from 'react';
import {
    //ConvertResultMessage,
    HtmlToPDFDialog,
    ExportImagesDialog,
    PDFToImageDialog,
    //SaveToDialog,
    //MessageDialog,
    //ToDoMessageDialog,
    TrustManagerDialog,
    WatermarkDialog,
    BackgroundDialog,
    AddHeaderFooter,
    FlattenPageDlg,
    AppendWebLinksdialog,
    EditViewWebLinksDlg,
    BatesNumberingDialog,
    ImportCommentDlg,
    CommentStatisticsResultDlg,
    EsignCnPagingSeal,
    EsignCnManageOutSeals,
    PaperCheckNoticeInfoDialog,
    PaperCheckMessageDialog,
    PaperCheckResultNoticeMessage,
    AddDigitalID,
    ChooseFiles4Organize,
    SignResultDialog,
    EsignCnStamp4MultPages,
    ESignSwitchAccountsDialog,
    EsignCnShareOnlineDocDialog,
    EsignCnOutStampsPanel,
    EsignCnApplyOrgSeals,
    EsignCnAuthPromotion
} from '../dialogs/index';
const UpdateLogsDlg = lazy(()=>import('../UpdateLogs/index'))

export const DLG_TARGETS = {
    Flatten: 'Flatten',
    Html2PDF: 'Html2PDF',
    AppendWebLinks: 'AppendWebLinks',
    ImportComment:'ImportComment',
    CommentStatisticsResult:'CommentStatisticsResult',
    EditViewWebLinks: 'EditViewWebLinks',
    ExportImage: 'ExportImage',
    ToImage: 'ToImage',
    ToDo: '',
    SaveTo: '',
    Optimizer: '',
    Watermark: 'Watermark',
    Background: 'Background',
    TrustManager: 'TrustManager',
    Security: 'Security',
    AddHeaderFooter: 'AddHeaderFooter',
    BatesNumberingDialog: 'BatesNumberingDialog',
    UpdateLogsDlg: 'UpdateLogsDlg',
    EsignCnPagingSeal: 'EsignCnPagingSeal',
    EsignCnManageOutSeals: 'EsignCnManageOutSeals',
    PaperCheckNoticeInfoDialog: 'PaperCheckNoticeInfoDialog',
    PaperCheckMessageDialog: 'PaperCheckMessageDialog',
    PaperCheckResultNoticeMessage: 'PaperCheckResultNoticeMessage',
    EsignCnStamp4MultPages: 'EsignCnStamp4MultPages',
    ESignSwitchAccountsDialog: 'ESignSwitchAccountsDialog',
    EsignCnShareOnlineDocDialog: 'EsignCnShareOnlineDocDialog',
    EsignCnOutStampsPanel: 'EsignCnOutStampsPanel',
    EsignCnApplyOrgSeals: 'EsignCnApplyOrgSeals',
    EsignCnAuthPromotion: 'EsignCnAuthPromotion',
};

const list = {
        Flatten: FlattenPageDlg,
        Html2PDF: HtmlToPDFDialog,
        AppendWebLinks: AppendWebLinksdialog,
        EditViewWebLinks: EditViewWebLinksDlg,
        ImportComment:ImportCommentDlg,
        CommentStatisticsResult:CommentStatisticsResultDlg,
        ExportImage: ExportImagesDialog,
        ToImage: PDFToImageDialog,
        UpdateLogsDlg: UpdateLogsDlg,
        //ToDo: ToDoMessageDialog,
        //SaveTo: SaveToDialog,
        //Optimizer: '',
        Watermark: WatermarkDialog,
        Background: BackgroundDialog,
        AddHeaderFooter: AddHeaderFooter,
        BatesNumberingDialog: BatesNumberingDialog,
        TrustManager: TrustManagerDialog,
        AddDigitalID:AddDigitalID,
        BatchSign:ChooseFiles4Organize,
        SignResultDialog:SignResultDialog,
        EsignCnPagingSeal,
        EsignCnManageOutSeals,
        PaperCheckNoticeInfoDialog,
        PaperCheckMessageDialog,
        PaperCheckResultNoticeMessage,
        EsignCnStamp4MultPages,
        ESignSwitchAccountsDialog,
        EsignCnShareOnlineDocDialog,
        EsignCnOutStampsPanel,
        EsignCnApplyOrgSeals,
        EsignCnAuthPromotion,
    };
    // item {Dialog,toCache}
let _dialogContainer = {}


/**
 *
 *
 * @export
 * @param {Object} props
 * @param {String} props.target
 * @param {Object} props.config
 * @param {Boolean} props.toCache
 * @returns
 */
export function DialogContainer({ target, config = {}, toCache,spinning=true }) {
    let  Dialog2;
    if(['function','object'].indexOf(typeof target)!==-1){
        Dialog2 = target;
    }else{
        if (!target) {
            Object.keys(_dialogContainer).forEach((key) => {
                let obj = _dialogContainer[key];
                !obj.toCache && delete _dialogContainer[key]
            })
            return(<></>)
        }

        const Dialog = list[target];
        if(!Dialog)return(<></>);

        if (!!Dialog && !_dialogContainer[target]) {
            (_dialogContainer[target] = { Dialog, toCache });
        }
        Dialog2  = _dialogContainer[target].Dialog
    }

    return ( <Suspense fallback={<div className="suspense-container"><Spin spinning={spinning} size="large" ></Spin></div>} >
                < Dialog2 visible={true} {...config }/>
            </Suspense>)
}
